export default function MarqueeStrip({ dark = true }) {
  const words = ["Discover Campania", "Live the Experience", "Campi Flegrei", "Islands", "Vesuvius", "Amalfi Coast", "Apennines", "Taste Campania"];
  const row = [...words, ...words];
  return (
    <div className={`overflow-hidden py-6 border-y ${dark ? "bg-ink border-ink" : "bg-ivory border-stone2/50"}`} data-testid="marquee-strip">
      <div className="marquee-track flex whitespace-nowrap">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-serif italic text-2xl md:text-3xl px-6 ${dark ? "text-ivory/80" : "text-ink/60"}`}>{w}</span>
            <span className={`w-1.5 h-1.5 rotate-45 ${dark ? "bg-terracotta" : "bg-medblue"}`} />
          </span>
        ))}
      </div>
    </div>
  );
}
